'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useProps } from '@s7/styles';
import { objectEntries } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var compound = function(baseIdent, Component, displayName) {
    return function(definition) {
        var forwardComponent = function(localIdent, presetProps) {
            if (presetProps === void 0) presetProps = {};
            var component = /*#__PURE__*/ forwardRef(function(_props, ref) {
                var _useProps = useProps(baseIdent, presetProps, _props), props = _useProps[0], sxs = _useProps[1];
                return /*#__PURE__*/ jsx(Component, _extends({
                    ref: ref
                }, props, sxs, {
                    __ident: [
                        baseIdent,
                        localIdent
                    ].join("")
                }));
            });
            return component;
        };
        var BaseComponent = forwardComponent();
        BaseComponent.displayName = displayName || baseIdent;
        var presets = definition.presets, components = definition.components;
        if (presets) {
            objectEntries(presets).forEach(function(param) {
                var localIdent = param[0], preset = param[1];
                var component = forwardComponent(localIdent, preset);
                component.displayName = [
                    baseIdent,
                    localIdent
                ].join(".");
                BaseComponent[localIdent] = component;
            });
        }
        if (components) {
            objectEntries(components).forEach(function(param) {
                var localIdent = param[0], component = param[1];
                component.displayName = [
                    baseIdent,
                    localIdent
                ].join(".");
                BaseComponent[localIdent] = component;
            });
        }
        return BaseComponent;
    };
};

export { compound };
